import React from 'react';
import useContext from '../../../../hooks/useContext';
import { Heading, ProductPageHeadline, Tail } from '../../../../styled/Headline/wrappers';
import { ProductContext } from '../providers/ProductProvider';

const Header = () => {
  const { name, description } = useContext(ProductContext);

  return (
    <ProductPageHeadline as="h1" className="large">
      <Heading>{name}</Heading>
      <Tail>{description}</Tail>
    </ProductPageHeadline>
  );
};

export default Header;
